import { PILLARS } from "../data/pillars";
import { T } from "../styles/theme";

interface PillarFilterProps {
  pillar: string;
  onChange: (key: string) => void;
}

/** Row of pillar pills used to filter the daily view. */
export function PillarFilter({ pillar, onChange }: PillarFilterProps) {
  return (
    <div
      style={{
        display: "flex",
        gap: 5,
        marginBottom: 12,
        overflowX: "auto",
        scrollbarWidth: "none",
        paddingBottom: 2,
      }}
    >
      {PILLARS.map((p) => {
        const active = pillar === p.key;
        return (
          <button
            key={p.key}
            onClick={() => onChange(p.key)}
            style={{
              flex: "0 0 auto",
              padding: "7px 12px",
              fontSize: 10,
              fontWeight: 700,
              fontFamily: T.body,
              border: active ? `2px solid ${T.terra}` : `2px solid ${T.parchment}`,
              borderRadius: 20,
              background: active ? "#6b3fa0" : T.white,
              color: active ? T.white : T.inkMid,
              cursor: "pointer",
              transition: "all 0.2s",
              whiteSpace: "nowrap",
              boxShadow: active ? "0 2px 8px rgba(107,63,160,0.3)" : "none",
            }}
          >
            {p.icon} {p.label}
          </button>
        );
      })}
    </div>
  );
}
